import { makeStyles } from '@mui/styles';

export const useDeliveryContainerUtilisationCardStyles = makeStyles((theme) => ({
  card: {
    padding: '24px',
    borderRadius: '10px'
  },
  divider: {
    borderBottom: '1px solid #EBEDF2',
    width: 'calc(100% + 32px)',
    height: '1px',
    marginLeft: '-16px',
    marginRight: '-16px',
    marginBottom: '24px'
  },
  sectionTitle: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '12px'
  },
  sectionSpacer: {
    marginTop: theme.spacing(4)
  },
  errorMessage: {
    color: theme.palette.error.main,
    fontFamily: 'Poppins',
    fontSize: '14px',
    padding: '32px 0'
  }
}));
